import { Component, OnInit } from '@angular/core';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { ApiService } from '../../shared/api.service';
import { EventSendeurService } from '../../shared/event-sendeur.service';
import { EditCritereComponent } from './edit-critere/edit-critere.component';
import { LocalDataSource } from 'ng2-smart-table';
import { ActivatedRoute, Router } from '@angular/router';
import { plainToClass } from 'class-transformer';
import { Categorie } from '../../shared/data/categorie';
import swal from 'sweetalert2';
import { Critere } from '../../shared/data/critere';
import { MediathequeComponent } from '../../shared/mediatheque/mediatheque.component';

@Component({
  selector: 'ngx-critere',
  templateUrl: './critere.component.html',
  styleUrls: ['./critere.component.scss']
})
export class CritereComponent implements OnInit {

  categories:any =[];
  
  source: LocalDataSource =  new LocalDataSource();
   settings = {
 
     hideSubHeader: false,
     mode: 'external',
     actions: {
      columnTitle: '',
      position: 'left',
      add: true,
      edit: true,
      delete: true,
     },
     add: {
      addButtonContent: '<i class="nb-plus"></i>',
      confirmCreate: false,
    },
     edit: {
       editButtonContent: '<i class="nb-edit"></i>',
       saveButtonContent: '<i class="nb-checkmark"></i>',
       cancelButtonContent: '<i class="nb-close"></i>',
       confirmSave:false
     },
     delete: {
       deleteButtonContent: '<i class="nb-trash"></i>',
       confirmDelete: true,
     },
   columns: {
     /* id: {
       title: 'ID',
       type: 'number',
       filter: false,
     }, */
     label: {
       title: 'Designation',
       type: 'string',
     },
     /* type_critere: {
       title: 'Type',
       type: 'string',
     }, */
   },
   pager : {
                 perPage :10
   },
  
 };

 param = "";

 titre = '';

 constructor(public route: ActivatedRoute, private router:Router,private dialogService: NbDialogService,private apiService:ApiService,private sendeurService:EventSendeurService,private toastr:NbToastrService) { 

  
    this.route.params.forEach(params => {
    
        this.param = params['type'];

        if (params['type'] === 'pays' || params['type'] === 'cycle' || params['type'] === 'admissibility' || params['type'] === 'partner' || params['type'] === 'particularity' || params['type'] === 'secteur' || params['type'] === 'type_ecole' || params['type'] === 'catformation' || params['type'] === 'niveau' || params['type'] === 'daterentree' || params['type'] === 'secteur_metier' || params['type'] === 'salaire' || params['type'] === 'alternance' || params['type'] === 'selectivite' || params['type'] === 'insertion' || params['type'] === 'type_contrat')  {

          // this.getCurrentDay();
          // this.settingService.getCurrentDay();
          this.ngOnInit();
        }

    });


 }
 
 ngOnInit() {


  switch(this.param) { 
    case 'cycle': { 
       //statements; 
       this.titre = 'Cycles';
       break; 
    } 
    case 'pays': { 
       //statements; 
       this.titre = 'Pays';
       break; 
    } 
    case 'partner': { 
      //statements; 
      this.titre = 'Partenaires';
      break; 
    } 
    case 'admissibility': { 
      //statements; 
      this.titre = 'Admissibilités';
      break; 
    }
    case 'particularity': { 
      //statements; 
      this.titre = 'Particularités';
      break; 
    }
    case 'type_ecole': { 
      //statements; 
      this.titre = 'Type d\'écoles';
      break; 
    }
    case 'secteur': { 
      //statements; 
      this.titre = 'Secteurs';
      break; 
    }
    case 'catformation': { 
      //statements; 
      this.titre = 'Catégories';
      break; 
    } 
    case 'niveau': { 
      //statements; 
      this.titre = 'Niveau requis';
      break; 
    }
    case 'daterentree': { 
      //statements; 
      this.titre = 'Date Rentrée';
      break; 
    }
    case 'secteur_metier': { 
      //statements; 
      this.titre = 'Secteurs';
      break; 
    }
    case 'salaire': { 
      //statements; 
      this.titre = 'Salaire';
      break; 
    }
    case 'alternance': { 
      //statements; 
      this.titre = 'Alternance';
      break; 
    }
    case 'selectivite': { 
      //statements; 
      this.titre = 'Sélectivité';
      break; 
    }
    case 'insertion': { 
      //statements; 
      this.titre = 'Insertion';
      break; 
    }
    case 'type_contrat': { 
      //statements; 
      this.titre = 'Type de contrat';
      break; 
    }
    default: { 
       //statements; 
       break; 
    } 
  } 

    
    if(this.route.snapshot.params['type'] !== 'all')
    this.param = this.route.snapshot.params['type']


    this.getCriteres();

    this.sendeurService.critereEvent.subscribe( data => {
        this.getCriteres();
    })

    /* this.sendeurService.categoryEvent.subscribe(data =>{
      this.getCategories();
    }) */

  }

 

  getCriteres(){

   
    this.apiService.getAllCritereProvider(this.param).subscribe(data =>{
     

      this.source.load( plainToClass( Critere, data) );
      /* const tmps = data as any[];   
      this.categories = tmps.map(tmp => {
        return {
        
          nom: tmp.nom,   
          id:tmp.id,
          description:tmp.description
        };
      
      }); */

    })

  }

  
  

  onDelete(event){
    // this.dialogService.open(DeleteCategoryComponent,{ context:{id:$event.data.id}});

    // this.dialogService.open(DeletePageComponent,{context:{id:$event.data.id}});
    const crit = plainToClass( Critere,  event.data as object);
    
    swal({
      title: 'Suppression critere',
      text: 'Voulez - vous vraiment supprimer ' + crit.label + ' ? Vous ne pourrez plus annuler cet opération',
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      cancelButtonText: 'Annuler',
      confirmButtonText: 'Confirmer',
      showLoaderOnConfirm: true,
      allowOutsideClick: false,
      preConfirm: () => {

        // this.dialogIsNotShow = true;

        return this.apiService.deleteCritereProvider(crit.id).subscribe(data =>{
          
          // console.log(data);
          this.source.remove(event.data);

          this.toastr.success("Suppréssion réussie", crit.label);
         
        },(err) =>{
          this.toastr.danger("Echec de suppréssion ");
          if(err.error.code ===401){
            localStorage.clear();
            window.location.reload();
            let link2 = ['/login'];
            this.router.navigate(link2);
          }
    
          if(err.error.code ===500){
          
            this.toastr.danger("Le serveur est actuellement indisponible, veuillez patienter ou actualiser la page");
         }
        })

      },
    }).then((result) => {

      if (result.value) {

        // this.toastr.success("Suppréssion réussie", crit.label);

      }

      // this.dialogIsNotShow = false;

    });


  }

  
  select($event){
    this.dialogService.open(EditCritereComponent,{context:{id:$event.data.id}});
  }

  onCreate(event){
    this.createCritere();
  }

  createCritere(){
    this.dialogService.open(EditCritereComponent,{context:{id:0, typecrit: this.param}});
  }


  

  

}
